"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAppReleaseEnvelope = checkAppReleaseEnvelope;
const permission_snapshot_contract_1 = require("@streamlain/permission-snapshot-contract");
const app_base_contract_1 = require("./app-base-contract");
const app_release_digests_1 = require("./app-release-digests");
const local_authority_envelope_1 = require("./local-authority-envelope");
const refused = { status: 'invalid', release: null };
/**
 * The checklist of every App release checker, the platform frontend and the
 * service worker of an App address: signature, key id and purpose
 * 'permission-grant', expiry, subject type, exactly one grant, the scope the
 * checker expects (`accepts`), the digest of the manifest about to run and,
 * when the files are given, the digest of their `{ path: sha256 }` map.
 */
async function checkAppReleaseEnvelope(envelope, options) {
    const verification = await (0, local_authority_envelope_1.verifyLocalAuthorityEnvelope)(envelope, {
        publicKeySpki: options.publicKeySpki,
        expectedKid: options.expectedKid,
        expectedPurpose: 'permission-grant',
        now: options.now,
    });
    if (verification.status === 'missing-key')
        return { status: 'missing-key', release: null };
    // The same key, kid and purpose also sign permission snapshots: refuse any
    // other subject before a field of the payload is read.
    if (verification.status === 'invalid' ||
        !(0, permission_snapshot_contract_1.isAppReleaseSnapshotPayload)(verification.payload))
        return refused;
    const payload = verification.payload;
    const grant = payload.grants.length === 1 ? payload.grants[0] : null;
    const manifest = app_base_contract_1.AppManifestSchema.safeParse(options.manifest);
    if (!grant || !manifest.success || !options.accepts(payload, grant))
        return refused;
    const digests = await (0, app_release_digests_1.appReleaseDigests)({
        manifest: manifest.data,
        artifactFiles: options.artifactFiles ?? {},
    });
    if (digests.manifestDigest !== grant.manifestDigest ||
        (options.artifactFiles !== undefined &&
            digests.artifactDigest !== grant.artifactDigest))
        return refused;
    return {
        status: verification.status,
        release: { payload, grant, manifest: manifest.data },
    };
}
